import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class JobTypeService {
    private headers: HttpHeaders = new HttpHeaders();

    constructor(private http: HttpClient) {
        this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

    GetJobTypeById(jobTypeId) {
        return this.http.get<any>('Job/GetJobTypeById/' + jobTypeId + '', { headers: this.headers })
    }

    ActiveOrDeactiveJobType(jobTypeId, isDeleted) {
        return this.http.get<any>('Job/ActiveOrDeactiveJobType?jobTypeId=' + jobTypeId + '&isDeleted=' + isDeleted)
    }

    ActiveOrDeactiveEntityType(entityTypeId, isDeleted) {
        return this.http.get<any>('Entity/ActiveOrDeactiveEntityType?entityTypeId=' + entityTypeId + '&isDeleted=' + isDeleted)
    }

    AddJobPriorityValues(values) {
        return this.http.post<any>('Job/AddEditJobPriority', values, { headers: this.headers });
    }

    sortJobPriority(value) {
        return this.http.post<any>('Job/sortJobPriority', value, { headers: this.headers });
    }
    
    GetJobPriorityValues() {
        return this.http.get<any>('Job/GetJobPriorityValues', { headers: this.headers })
    }

    SetDefaultJobPriority(jobPriorityId: number) {
        return this.http.get<any>('Job/SetDefaultJobPriority?jobPriorityId=' + jobPriorityId, { headers: this.headers });
    }
}
